import { addDays, addMonths, getStartOfISOWeek, MAX_DATE, MIN_DATE, sameDay } from '@cumlaude/shared-utils';

export enum DateRangeView {
	MAAND = 'Maand',
	WEEK = 'Week',
	DAG = 'Dag',
	AFGELOPEN = 'Afgelopen...',
	VANAF = 'Vanaf',
	TOT_EN_MET = 'Tot en met',
	AANGEPAST = 'Aangepast',
	ONBEKEND = 'Onbekend',
}

export interface DateRange {
	from: Date;
	to: Date;
}

/**
 * De view die bij een range past. Alle views die uit alleen een range volgen worden ondersteund, anders
 * Aangepast. Afgelopen hoort daar niet bij: dat vraagt een apart veld `relative`.
 */
export function resolveDateRangeView({ from, to }: DateRange): DateRangeView {
	if (sameDay(to, MAX_DATE)) return DateRangeView.VANAF;
	if (sameDay(from, MIN_DATE)) return DateRangeView.TOT_EN_MET;
	if (sameDay(from, to)) return DateRangeView.DAG;
	if (sameDay(from, getStartOfISOWeek(from)) && sameDay(to, addDays(from, 6))) return DateRangeView.WEEK;
	if (from.getDate() === 1 && sameDay(to, addDays(addMonths(from, 1), -1))) return DateRangeView.MAAND;
	return DateRangeView.AANGEPAST;
}
